import { render, staticRenderFns } from "./VaDisclaimer.vue?vue&type=template&id=513a1aa6&scoped=true&"
import script from "./VaDisclaimer.vue?vue&type=script&lang=js&"
export * from "./VaDisclaimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513a1aa6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
